import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppConfig } from 'app/app.config';
import { IDtoCatalog } from 'app/shared/models/dto-catalog.model';
import { IDtoLiquidation } from 'app/shared/models/legal/dto-liquidation.model';
import { IDtoBudget } from 'app/shared/models/quote/budget.model';
import { IDtoModuleLog } from 'app/shared/models/security/dto-module-log.model';
import { ConfigurationService } from 'app/shared/services/configuration.service';
import { SecurityService } from 'app/shared/services/security.service';
import { LiquidationService } from 'app/views/appviews/liquidation.service';
import { BudgetService } from 'app/views/appviews/quote/budget.service';
import { IdentityService } from 'app/views/appviews/security/identity.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-approve-conciliation-own',
  templateUrl: 'approve-conciliation-own.template.html'
})
export class ApproveConciliationOwnComponent implements OnInit {
  public nav: any;
  private errorMessages: any;
  private title: string;
  private description1: string;
  private description2: string;
  constructor(private serviceSecurity: SecurityService
    , private configurationService: ConfigurationService
    , private route: ActivatedRoute
    , private config: AppConfig
    , private spinner: NgxSpinnerService
    , private liquidationService: LiquidationService
    , private identityService: IdentityService) {
  }

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      if (params['url']) {
        if (this.configurationService.isReady) {
          let u = params['url'];
          this.approveOwnConciliation(u);
        } else {
          this.configurationService.settingsLoaded$.subscribe(x => {
            let u = params['url'];
            this.approveOwnConciliation(u);
          });
        }
      }
    });
  }
  private approveOwnConciliation(id: number): void {
    this.spinner.show()
    this.liquidationService.approveOwnConciliation(id)
      .subscribe(
        (x) => {
          if (x.isCorrect) {
            this.title = 'Conciliación propia aprobada';
            this.description1 = 'Para alguna duda o aclaración, ponerse en contacto con el area de Legal.';
            this.addModuleLog(x.data as IDtoLiquidation);
          } else {
            this.title = x.exception;
            this.description1 = 'Favor de notificar el error al área de legal o ponerse en contacto con el área de soporte.';
          }
          this.spinner.hide();
        },
        (errMessage) => this.errorMessages = errMessage.messages);
  }
  private addModuleLog(res: IDtoLiquidation): void {
    let dto = {} as IDtoModuleLog;
    dto.table = 'Liquidations';
    dto.module = 'liquidation';
    dto.action = 'approval';
    dto.registryAffectedId = res.id;
    //dto.userId = res.approverUserId;
    dto.employeeId = null;
    dto.role = 'Aprobador';
    this.identityService.addModuleLogComplete(dto).subscribe(
      (x) => { });
  }
}
